import axios from "axios";
import { getCurrentIdToken } from "../Auth";

const USER_DATA_BASE_URL = `${import.meta.env.VITE_API_BASE_URL}/userdata`;

function userDataUrl(key) {
  // encoding the key allows it to have things like spaces and slashes
  return `${USER_DATA_BASE_URL}/${encodeURIComponent(key)}`;
}

export async function getRemoteUserData(key) {
  const url = userDataUrl(key);
  const idToken = getCurrentIdToken();
  const options = { headers: { Authorization: `Bearer ${idToken}` } };
  const response = await axios.get(url, options);
  return response.data;
}

export async function setRemoteUserData(key, data) {
  const idToken = getCurrentIdToken();
  const options = {
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
  };
  const url = userDataUrl(key);
  await axios.post(url, JSON.stringify(data), options);
}
